import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/AmenityManageApi/AmenityManage";
import { validateForm } from "utils/validation";
import { AmenityRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditAmenityForm from "./Components/EditAmenityForm";
import fields from "../json/AmenityFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const AmenityEdit = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const { id } = useParams();

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => {
    if (field.name === "features") {
      return { ...acc, [field.name]: [] };
    }
    return { ...acc, [field.name]: "" };
  }, {});

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    AmenityRules
  );

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Form submit handler
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();

      Object.entries(formValues).forEach(([key, val]) => {
        // Skip imagePreview and skip image if it's a string or number (existing URL/ID, not a new file)
        if (key === "imagePreview") return;
        if (key === "image" && (typeof val === "string" || typeof val === "number")) return;

        if (key === "features" && Array.isArray(val)) {
          // Separate file objects from features data
          const featuresWithoutFiles = val.map((f) => ({
            name: f.name,
            icon: f.icon && typeof f.icon === "object" ? null : (f.icon || null),
            icon_url: f.icon_url || null,  // ← preserve so preview works after save
          }));
          formData.append(key, JSON.stringify(featuresWithoutFiles));

          // Append feature icon files as separate fields
          val.forEach((feature, index) => {
            if (feature.icon && typeof feature.icon === "object") {
              formData.append(`feature_icon_${index}`, feature.icon);
            }
          });
        } else {
          formData.append(key, val ?? "");
        }
      });

      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, AmenityRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Amenity updated successfully"
  );


  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditAmenityForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        iconPreview={values.iconPreview || values.icon}
        title="Update Amenity"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default AmenityEdit;
